import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  id: string;
  enabled?: boolean;
}

/** Another user's notebook and a missing one both come back 404 (the API never leaks existence). */
const hasNotFoundStatus = (error: unknown): boolean =>
  (error as { response?: { status?: number } } | null)?.response?.status === 404;

const useSingle = ({ id, enabled = true }: IProps) => {
  const query = useQuery({
    queryKey: ['notebooks', id],
    queryFn: async () => {
      const response = await Api.single(id);
      return response.data.data;
    },
    enabled: enabled && Boolean(id),
  });

  return {
    notebook: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isNotFound: query.isError && hasNotFoundStatus(query.error),
    error: query.error,
    refetch: query.refetch,
  };
};

export default useSingle;
